webpackJsonp([137],{

/***/ 1292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfTrainingExamination_vue__ = __webpack_require__(3050);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518a269e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfTrainingExamination_vue__ = __webpack_require__(5646);
function injectStyle (ssrContext) {
  __webpack_require__(5644)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-518a269e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfTrainingExamination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518a269e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfTrainingExamination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(22);


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(12);
var LIBRARY = __webpack_require__(104);
var wksExt = __webpack_require__(1350);
var defineProperty = __webpack_require__(54).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(244);
var hiddenKeys = __webpack_require__(148).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1365);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1366);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1368), __esModule: true };

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1369), __esModule: true };

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(235);
var createDesc = __webpack_require__(103);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var has = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(243);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(234);
module.exports = __webpack_require__(1350).f('iterator');


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1370);
__webpack_require__(241);
__webpack_require__(1373);
__webpack_require__(1374);
module.exports = __webpack_require__(12).Symbol;


/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(40);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(245);
var META = __webpack_require__(1353).KEY;
var $fails = __webpack_require__(76);
var shared = __webpack_require__(147);
var setToStringTag = __webpack_require__(105);
var uid = __webpack_require__(144);
var wks = __webpack_require__(22);
var wksExt = __webpack_require__(1350);
var wksDefine = __webpack_require__(1351);
var enumKeys = __webpack_require__(1371);
var isArray = __webpack_require__(1356);
var anObject = __webpack_require__(41);
var isObject = __webpack_require__(55);
var toObject = __webpack_require__(78);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var createDesc = __webpack_require__(103);
var _create = __webpack_require__(240);
var gOPNExt = __webpack_require__(1372);
var $GOPD = __webpack_require__(1367);
var $GOPS = __webpack_require__(237);
var $DP = __webpack_require__(54);
var $keys = __webpack_require__(101);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(1354).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(235).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(104)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(237);
var pIE = __webpack_require__(235);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(100);
var gOPN = __webpack_require__(1354).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('asyncIterator');


/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('observable');


/***/ }),

/***/ 1505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["h"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* unused harmony export getFileExtension */
/* unused harmony export getCourseContentTypeByFile */
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);




var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  KNOWLEDGE_STATUS_ACTIVE: 2,

  CONTENT_TYPE_IMAGE: 1,
  CONTENT_TYPE_VIDEO: 2
  // CONTENT_TYPE_DOCUMENT: 3,
};

var opts = {
  contentTypeMaps: [{ value: consts.CONTENT_TYPE_IMAGE, label: '图片' }, { value: consts.CONTENT_TYPE_VIDEO, label: '视频' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  tip: '支持 JPG、PNG，可上传多张，单个最大 20MB'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 1,
  maxSizeMB: 1024,
  tip: '只能上传一个视频，支持 MP4、AVI、MOV，最大 1GB'
  // [consts.CONTENT_TYPE_DOCUMENT]: {
  //   accept: ['application/pdf'],
  //   extensions: ['pdf'],
  //   maxFiles: 1,
  //   maxSizeMB: 100,
  //   tip: '只能上传一个 PDF，最大 100MB',
  // },
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseContentTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_IMAGE;
  }
  if (type.indexOf('video/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_VIDEO].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_VIDEO;
  }
  // if (type === 'application/pdf' || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_DOCUMENT].extensions.includes(ext)) {
  //   return consts.CONTENT_TYPE_DOCUMENT
  // }
  return 0;
}

function getCourseUploadConfig(contentType) {
  if (!contentType) {
    var configs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
      return COURSE_UPLOAD_TYPE_CONFIGS[type];
    });
    return {
      accept: configs.reduce(function (result, item) {
        return result.concat(item.accept);
      }, []),
      extensions: configs.reduce(function (result, item) {
        return result.concat(item.extensions);
      }, []),
      maxFiles: 0,
      maxSizeMB: Math.max.apply(null, configs.map(function (item) {
        return item.maxSizeMB;
      })),
      tip: '支持上传图片、视频；图片可上传多张，视频只能上传一个'
    };
  }

  return COURSE_UPLOAD_TYPE_CONFIGS[Number(contentType)] || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE];
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var contentType = getCourseContentTypeByFile(file);
  if (!contentType) {
    return {
      valid: false,
      contentType: contentType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(contentType);
  var currentCount = Array.isArray(currentFiles) ? currentFiles.length : 0;
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (config.maxFiles === 1) {
    return {
      valid: true,
      contentType: contentType,
      message: '',
      replaceAll: currentCount >= 1 || currentFiles.some(function (item) {
        return Number(item.content_type || item.type || currentContentType) !== contentType;
      })
    };
  }

  return {
    valid: true,
    contentType: contentType,
    message: '',
    replaceAll: currentFiles.some(function (item) {
      return Number(item.content_type || item.type || currentContentType) !== contentType;
    })
  };
}

/***/ }),

/***/ 1526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["d"] = createOptionUuid;
/* harmony export (immutable) */ __webpack_exports__["c"] = createDefaultQuestionOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOptionLetter;
/* harmony export (immutable) */ __webpack_exports__["p"] = resetQuestionAnswerByType;
/* harmony export (immutable) */ __webpack_exports__["k"] = isChoiceQuestion;
/* harmony export (immutable) */ __webpack_exports__["l"] = isNumericAnswer;
/* harmony export (immutable) */ __webpack_exports__["j"] = getQuestionTypeLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getQuestionStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["h"] = getQuestionStatusType;
/* harmony export (immutable) */ __webpack_exports__["f"] = getQuestionStatusActions;
/* harmony export (immutable) */ __webpack_exports__["m"] = isQuestionRelationEditLocked;
/* unused harmony export isQuestionBaned */
/* harmony export (immutable) */ __webpack_exports__["n"] = isQuestionUsedOrBaned;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQuestionKnowledgeQueryParams;
/* harmony export (immutable) */ __webpack_exports__["i"] = getQuestionSubmitPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__ = __webpack_require__(1505);



var consts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["b" /* consts */], {
  QUESTION_TYPE_SINGLE: 1, // 单选题
  QUESTION_TYPE_MULTI: 2, // 多选题
  QUESTION_TYPE_FILL_BLANK: 3, // 填空题

  QUESTION_STATUS_NEW: 1, // 新创建
  QUESTION_STATUS_USING: 2, // 使用中
  QUESTION_STATUS_UNUSED: 3, // 未使用
  QUESTION_STATUS_BANNED: 4 // 已作废
});

var opts = {
  targetUserMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].targetUserMaps,
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].isCommonMaps,
  statusMaps: [{ value: consts.QUESTION_STATUS_NEW, label: '新创建' }, { value: consts.QUESTION_STATUS_UNUSED, label: '未使用' }, { value: consts.QUESTION_STATUS_USING, label: '使用中' }, { value: consts.QUESTION_STATUS_BANNED, label: '已作废' }],
  questionTypeMaps: [{ value: consts.QUESTION_TYPE_SINGLE, label: '单选题' }, { value: consts.QUESTION_TYPE_MULTI, label: '多选题' }, { value: consts.QUESTION_TYPE_FILL_BLANK, label: '填空题' }]
};

function createOptionUuid() {
  return 'opt' + Math.random().toString(16).slice(2) + Date.now();
}

function createDefaultQuestionOptions() {
  return ['A', 'B', 'C', 'D'].map(function (letter) {
    return {
      uuid: createOptionUuid(),
      title: '\u9009\u9879' + letter
    };
  });
}

function getOptionLetter(index) {
  return String.fromCharCode(65 + index);
}

function resetQuestionAnswerByType(type) {
  return Number(type) === consts.QUESTION_TYPE_MULTI ? [] : '';
}

function isChoiceQuestion(type) {
  return [consts.QUESTION_TYPE_SINGLE, consts.QUESTION_TYPE_MULTI].includes(Number(type));
}

function isNumericAnswer(value) {
  return (/^-?\d+(\.\d+)?$/.test(String(value).trim())
  );
}

function getQuestionTypeLabel(value) {
  var item = opts.questionTypeMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusLabel(value) {
  var item = opts.statusMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusType(status) {
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
      return 'success';
    case consts.QUESTION_STATUS_USING:
      return 'primary';
    case consts.QUESTION_STATUS_BANNED:
      return 'default';
    default:
      return 'warning';
  }
}

function getQuestionStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!isSuperAdmin) {
    return [];
  }
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
    case consts.QUESTION_STATUS_NEW:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingQuestion', successText: '作废成功' }];
    case consts.QUESTION_STATUS_BANNED:
      return [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingQuestion', successText: '激活成功' }];
    default:
      return [];
  }
}

function isQuestionRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.QUESTION_STATUS_UNUSED, consts.QUESTION_STATUS_USING, consts.QUESTION_STATUS_BANNED].includes(Number(status));
}

function isQuestionBaned(id, status) {
  return Number(id) > 0 && Number(status) === consts.QUESTION_STATUS_BANNED;
}

function isQuestionUsedOrBaned(id, status) {
  return Number(id) > 0 && (Number(status) === consts.QUESTION_STATUS_BANNED || Number(status) === consts.QUESTION_STATUS_USING);
}

function buildQuestionKnowledgeQueryParams(form) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["a" /* buildCourseKnowledgeQueryParams */])(form);
}

function getQuestionSubmitPayload(form) {
  var payload = {
    target_usertype: form.target_usertype,
    is_common: form.is_common,
    customerid: Number(form.is_common) === consts.IS_COMMON_SHARED ? 0 : form.customerid,
    training_knowledge_id: form.training_knowledge_id,
    question_type: form.question_type,
    question_json: {
      title: form.title,
      sample_files: form.sample_files || [],
      question_analysis: {
        analysis_text: form.analysis_text || '',
        analysis_files: form.analysis_files || []
      },
      standard_answer: form.standard_answer
    }
  };

  if (isChoiceQuestion(form.question_type)) {
    payload.question_json.options = form.options || [];
  }

  return payload;
}

/***/ }),

/***/ 1608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingMediaPreview',
  props: {
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      viewer: {
        visible: false,
        index: 0
      }
    };
  },

  computed: {
    normalizedFiles: function normalizedFiles() {
      return (this.files || []).filter(function (file) {
        return file && file.url && (file.type === 'img' || file.type === 'video');
      });
    },
    viewerIndex: function viewerIndex() {
      return this.viewer.index;
    },
    activeFile: function activeFile() {
      return this.normalizedFiles[this.viewerIndex] || null;
    },
    canGoPrev: function canGoPrev() {
      return this.viewerIndex > 0;
    },
    canGoNext: function canGoNext() {
      return this.viewerIndex < this.normalizedFiles.length - 1;
    }
  },
  mounted: function mounted() {
    document.addEventListener('keyup', this.onKeyup);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.onKeyup);
  },

  methods: {
    fileKey: function fileKey(file, index) {
      return file.uid || file.url || index;
    },
    openViewer: function openViewer(index) {
      if (index < 0 || index >= this.normalizedFiles.length) {
        return;
      }
      this.viewer.index = index;
      this.viewer.visible = true;
    },
    closeViewer: function closeViewer() {
      this.viewer.visible = false;
    },
    onViewerOpened: function onViewerOpened() {
      this.pauseVideo();
    },
    onViewerClosed: function onViewerClosed() {
      this.pauseVideo();
      this.viewer.index = 0;
    },
    viewIndex: function viewIndex(index) {
      if (index === this.viewerIndex || index < 0 || index >= this.normalizedFiles.length) {
        return;
      }
      this.pauseVideo();
      this.viewer.index = index;
    },
    viewPrev: function viewPrev() {
      if (!this.canGoPrev) {
        return;
      }
      this.viewIndex(this.viewerIndex - 1);
    },
    viewNext: function viewNext() {
      if (!this.canGoNext) {
        return;
      }
      this.viewIndex(this.viewerIndex + 1);
    },
    pauseVideo: function pauseVideo() {
      var player = this.$refs.videoPlayer;
      if (player && typeof player.pause === 'function') {
        player.pause();
      }
    },
    onKeyup: function onKeyup(event) {
      if (!this.viewer.visible) {
        return;
      }
      if (event.keyCode === 37) {
        this.viewPrev();
      } else if (event.keyCode === 39) {
        this.viewNext();
      }
    }
  }
});

/***/ }),

/***/ 1807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingMediaPreview_vue__ = __webpack_require__(1608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b0b448_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingMediaPreview_vue__ = __webpack_require__(1812);
function injectStyle (ssrContext) {
  __webpack_require__(1808)
  __webpack_require__(1810)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94b0b448"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingMediaPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b0b448_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingMediaPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1808:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1809);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1390a59c", content, true, {});

/***/ }),

/***/ 1809:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-media-preview[data-v-94b0b448]{margin-top:10px}.training-media-preview__grid[data-v-94b0b448]{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:10px;max-width:640px}.training-media-preview__item[data-v-94b0b448]{position:relative;aspect-ratio:1;border-radius:8px;overflow:hidden;cursor:pointer;background:#f2f2f2;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.08);box-shadow:0 2px 8px rgba(0,0,0,.08)}.training-media-preview__thumb[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block}.training-media-preview__video[data-v-94b0b448]{position:relative;width:100%;height:100%;background:#eef2f7}.training-media-preview__video-placeholder[data-v-94b0b448]{width:100%;height:100%;color:#c0c4cc;font-size:28px}.training-media-preview__play-overlay[data-v-94b0b448],.training-media-preview__video-placeholder[data-v-94b0b448]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.training-media-preview__play-overlay[data-v-94b0b448]{position:absolute;inset:0;background:rgba(15,23,42,.12)}.training-media-preview__play-overlay i[data-v-94b0b448]{width:44px;height:44px;border-radius:50%;background:rgba(64,158,255,.88);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:24px;-webkit-box-shadow:0 4px 12px rgba(0,0,0,.18);box-shadow:0 4px 12px rgba(0,0,0,.18)}.training-media-preview__viewer[data-v-94b0b448]{position:relative;width:100%;height:100vh;background:rgba(0,0,0,.92);overflow:hidden}.training-media-preview__viewer-close[data-v-94b0b448]{position:absolute;top:0;right:0;z-index:2003;background-color:hsla(0,0%,100%,.1);padding:30px;border:0;border-radius:0 0 0 100%;cursor:pointer}.training-media-preview__viewer-close[data-v-94b0b448]:hover{background-color:hsla(0,0%,100%,.2)}.training-media-preview__viewer-close i[data-v-94b0b448]{color:#fff;font-size:18px}.training-media-preview__viewer-counter[data-v-94b0b448]{position:absolute;top:10px;left:10px;z-index:2002;color:#909399;text-shadow:0 0 2px #000}.training-media-preview__viewer-counter-current[data-v-94b0b448]{font-size:22px;color:#fff}.training-media-preview__viewer-counter-total[data-v-94b0b448]{font-size:14px}.training-media-preview__viewer-body[data-v-94b0b448]{width:100%;height:calc(100% - 72px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:40px 72px 0;-webkit-box-sizing:border-box;box-sizing:border-box}.training-media-preview__viewer-image[data-v-94b0b448]{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.training-media-preview__viewer-video[data-v-94b0b448]{max-width:100%;max-height:100%;background:#000}.training-media-preview__viewer-nav[data-v-94b0b448]{z-index:2002}.training-media-preview__viewer-navbar[data-v-94b0b448]{position:absolute;left:0;right:0;bottom:0;z-index:2002;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:12px 16px 16px;overflow-x:auto;background:-webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.55)),to(transparent));background:linear-gradient(0deg,rgba(0,0,0,.55),transparent)}.training-media-preview__viewer-nav-item[data-v-94b0b448]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:56px;height:56px;border-radius:4px;overflow:hidden;cursor:pointer;opacity:.65;border:2px solid transparent;background:hsla(0,0%,100%,.08)}.training-media-preview__viewer-nav-item.is-active[data-v-94b0b448]{opacity:1;border-color:#409eff}.training-media-preview__viewer-nav-item img[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block}.training-media-preview__viewer-nav-video[data-v-94b0b448]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:22px}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingMediaPreview.vue"],"names":[],"mappings":"AACA,yCAAyC,eAAe,CACvD,AACD,+CAA+C,aAAa,0DAA4D,SAAS,eAAe,CAC/I,AACD,+CAA+C,kBAAkB,eAAe,kBAAkB,gBAAgB,eAAe,mBAAmB,6CAA8C,oCAAqC,CACtO,AACD,gDAAgD,WAAW,YAAY,oBAAoB,iBAAiB,aAAa,CACxH,AACD,gDAAgD,kBAAkB,WAAW,YAAY,kBAAkB,CAC1G,AACD,4DAA4D,WAAW,YAAY,AAA2L,cAAc,cAAc,CACzS,AACD,mHAFmF,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,sBAAuB,CAG7Q,AADD,uDAAuD,kBAAkB,QAAQ,AAA2L,6BAA8B,CACzS,AACD,yDAAyD,WAAW,YAAY,kBAAkB,gCAAiC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,eAAe,8CAA+C,qCAAsC,CAC5a,AACD,iDAAiD,kBAAkB,WAAW,aAAa,2BAA4B,eAAe,CACrI,AACD,uDAAuD,kBAAkB,MAAM,QAAQ,aAAa,oCAAuC,aAAa,SAAS,yBAAyB,cAAc,CACvM,AACD,6DAA6D,mCAAsC,CAClG,AACD,yDAAyD,WAAW,cAAc,CACjF,AACD,yDAAyD,kBAAkB,SAAS,UAAU,aAAa,cAAc,wBAAwB,CAChJ,AACD,iEAAiE,eAAe,UAAU,CACzF,AACD,+DAA+D,cAAc,CAC5E,AACD,sDAAsD,WAAW,yBAAyB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,oBAAoB,8BAA8B,qBAAqB,CAC3V,AACD,uDAAuD,eAAe,gBAAgB,sBAAsB,kBAAkB,CAC7H,AACD,uDAAuD,eAAe,gBAAgB,eAAe,CACpG,AACD,qDAAqD,YAAY,CAChE,AACD,wDAAwD,kBAAkB,OAAO,QAAQ,SAAS,aAAa,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,uBAAuB,gBAAgB,+FAAoG,4DAAiE,CAC3b,AACD,0DAA0D,mBAAmB,kBAAkB,cAAc,WAAW,YAAY,kBAAkB,gBAAgB,eAAe,YAAa,6BAA6B,8BAAiC,CAC/P,AACD,oEAAoE,UAAU,oBAAoB,CACjG,AACD,8DAA8D,WAAW,YAAY,oBAAoB,iBAAiB,aAAa,CACtI,AACD,2DAA2D,WAAW,YAAY,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,cAAc,CACrS","file":"TrainingMediaPreview.vue","sourcesContent":["\n.training-media-preview[data-v-94b0b448]{margin-top:10px\n}\n.training-media-preview__grid[data-v-94b0b448]{display:grid;grid-template-columns:repeat(auto-fill, minmax(120px, 1fr));gap:10px;max-width:640px\n}\n.training-media-preview__item[data-v-94b0b448]{position:relative;aspect-ratio:1;border-radius:8px;overflow:hidden;cursor:pointer;background:#f2f2f2;-webkit-box-shadow:0 2px 8px rgba(0,0,0,0.08);box-shadow:0 2px 8px rgba(0,0,0,0.08)\n}\n.training-media-preview__thumb[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block\n}\n.training-media-preview__video[data-v-94b0b448]{position:relative;width:100%;height:100%;background:#eef2f7\n}\n.training-media-preview__video-placeholder[data-v-94b0b448]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#c0c4cc;font-size:28px\n}\n.training-media-preview__play-overlay[data-v-94b0b448]{position:absolute;inset:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:rgba(15,23,42,0.12)\n}\n.training-media-preview__play-overlay i[data-v-94b0b448]{width:44px;height:44px;border-radius:50%;background:rgba(64,158,255,0.88);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:24px;-webkit-box-shadow:0 4px 12px rgba(0,0,0,0.18);box-shadow:0 4px 12px rgba(0,0,0,0.18)\n}\n.training-media-preview__viewer[data-v-94b0b448]{position:relative;width:100%;height:100vh;background:rgba(0,0,0,0.92);overflow:hidden\n}\n.training-media-preview__viewer-close[data-v-94b0b448]{position:absolute;top:0;right:0;z-index:2003;background-color:rgba(255,255,255,0.1);padding:30px;border:0;border-radius:0 0 0 100%;cursor:pointer\n}\n.training-media-preview__viewer-close[data-v-94b0b448]:hover{background-color:rgba(255,255,255,0.2)\n}\n.training-media-preview__viewer-close i[data-v-94b0b448]{color:#fff;font-size:18px\n}\n.training-media-preview__viewer-counter[data-v-94b0b448]{position:absolute;top:10px;left:10px;z-index:2002;color:#909399;text-shadow:0 0 2px #000\n}\n.training-media-preview__viewer-counter-current[data-v-94b0b448]{font-size:22px;color:#fff\n}\n.training-media-preview__viewer-counter-total[data-v-94b0b448]{font-size:14px\n}\n.training-media-preview__viewer-body[data-v-94b0b448]{width:100%;height:calc(100% - 72px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:40px 72px 0;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.training-media-preview__viewer-image[data-v-94b0b448]{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain\n}\n.training-media-preview__viewer-video[data-v-94b0b448]{max-width:100%;max-height:100%;background:#000\n}\n.training-media-preview__viewer-nav[data-v-94b0b448]{z-index:2002\n}\n.training-media-preview__viewer-navbar[data-v-94b0b448]{position:absolute;left:0;right:0;bottom:0;z-index:2002;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:12px 16px 16px;overflow-x:auto;background:-webkit-gradient(linear, left bottom, left top, from(rgba(0,0,0,0.55)), to(transparent));background:linear-gradient(to top, rgba(0,0,0,0.55), transparent)\n}\n.training-media-preview__viewer-nav-item[data-v-94b0b448]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:56px;height:56px;border-radius:4px;overflow:hidden;cursor:pointer;opacity:0.65;border:2px solid transparent;background:rgba(255,255,255,0.08)\n}\n.training-media-preview__viewer-nav-item.is-active[data-v-94b0b448]{opacity:1;border-color:#409eff\n}\n.training-media-preview__viewer-nav-item img[data-v-94b0b448]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block\n}\n.training-media-preview__viewer-nav-video[data-v-94b0b448]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:22px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1810:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1811);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7b823748", content, true, {});

/***/ }),

/***/ 1811:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-media-preview__viewer-dialog{margin:0!important;background:transparent;-webkit-box-shadow:none;box-shadow:none}.training-media-preview__viewer-dialog .el-dialog__header{display:none}.training-media-preview__viewer-dialog .el-dialog__body{padding:0}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingMediaPreview.vue"],"names":[],"mappings":"AACA,uCAAuC,mBAAoB,uBAAuB,wBAAwB,eAAe,CACxH,AACD,0DAA0D,YAAY,CACrE,AACD,wDAAwD,SAAS,CAChE","file":"TrainingMediaPreview.vue","sourcesContent":["\n.training-media-preview__viewer-dialog{margin:0 !important;background:transparent;-webkit-box-shadow:none;box-shadow:none\n}\n.training-media-preview__viewer-dialog .el-dialog__header{display:none\n}\n.training-media-preview__viewer-dialog .el-dialog__body{padding:0\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.normalizedFiles.length)?_c('div',{staticClass:"training-media-preview"},[_c('div',{staticClass:"training-media-preview__grid"},_vm._l((_vm.normalizedFiles),function(file,index){return _c('div',{key:_vm.fileKey(file, index),staticClass:"training-media-preview__item",on:{"click":function($event){return _vm.openViewer(index)}}},[(file.type === 'img')?_c('img',{staticClass:"training-media-preview__thumb",attrs:{"src":file.url,"alt":""}}):(file.type === 'video')?_c('div',{staticClass:"training-media-preview__video"},[_vm._m(0,true),_vm._v(" "),_vm._m(1,true)]):_vm._e()])}),0),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.viewer.visible,"width":"100%","top":"0","append-to-body":"","custom-class":"training-media-preview__viewer-dialog","close-on-click-modal":false,"close-on-press-escape":true,"show-close":false},on:{"update:visible":function($event){return _vm.$set(_vm.viewer, "visible", $event)},"closed":_vm.onViewerClosed,"opened":_vm.onViewerOpened}},[(_vm.viewer.visible)?_c('div',{staticClass:"training-media-preview__viewer"},[_c('button',{staticClass:"training-media-preview__viewer-close el-dialog__headerbtn",attrs:{"type":"button"},on:{"click":_vm.closeViewer}},[_c('i',{staticClass:"el-dialog__close el-icon el-icon-close"})]),_vm._v(" "),_c('div',{staticClass:"training-media-preview__viewer-counter"},[_c('span',{staticClass:"training-media-preview__viewer-counter-current"},[_vm._v(_vm._s(_vm.viewerIndex + 1))]),_vm._v(" "),_c('span',{staticClass:"training-media-preview__viewer-counter-total"},[_vm._v("/"+_vm._s(_vm.normalizedFiles.length))])]),_vm._v(" "),_c('div',{staticClass:"training-media-preview__viewer-body"},[(_vm.activeFile && _vm.activeFile.type === 'img')?_c('img',{key:'img-' + _vm.viewerIndex,staticClass:"training-media-preview__viewer-image",attrs:{"src":_vm.activeFile.url,"alt":""}}):(_vm.activeFile && _vm.activeFile.type === 'video')?_c('video',{key:'video-' + _vm.viewerIndex,ref:"videoPlayer",staticClass:"training-media-preview__viewer-video",attrs:{"src":_vm.activeFile.url,"controls":"","autoplay":"","playsinline":""}}):_vm._e()]),_vm._v(" "),(_vm.canGoPrev)?_c('span',{staticClass:"el-image-viewer__btn el-image-viewer__prev training-media-preview__viewer-nav",on:{"click":_vm.viewPrev}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e(),_vm._v(" "),(_vm.canGoNext)?_c('span',{staticClass:"el-image-viewer__btn el-image-viewer__next training-media-preview__viewer-nav",on:{"click":_vm.viewNext}},[_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"training-media-preview__viewer-navbar"},_vm._l((_vm.normalizedFiles),function(file,index){return _c('div',{key:'nav-' + _vm.fileKey(file, index),class:['training-media-preview__viewer-nav-item', { 'is-active': _vm.viewerIndex === index }],on:{"click":function($event){return _vm.viewIndex(index)}}},[(file.type === 'img')?_c('img',{attrs:{"src":file.url,"alt":""}}):_c('div',{staticClass:"training-media-preview__viewer-nav-video"},[_c('i',{staticClass:"el-icon-video-camera"})])])}),0)]):_vm._e()])],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-media-preview__video-placeholder"},[_c('i',{staticClass:"el-icon-video-camera"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-media-preview__play-overlay"},[_c('i',{staticClass:"el-icon-video-play"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__training_question_constants__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TrainingMediaPreview_vue__ = __webpack_require__(1807);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var STORAGE_PREFIX = 'self-training-exam:';

function operationId(prefix) {
  return (prefix || 'operation') + '-' + Date.now() + '-' + Math.random().toString(16).slice(2);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelfTrainingExamination',
  components: { TrainingMediaPreview: __WEBPACK_IMPORTED_MODULE_5__components_TrainingMediaPreview_vue__["a" /* default */] },
  data: function data() {
    return {
      title: '',
      questions: [],
      answers: {},
      version: 0,
      passing_score: 0,
      question_score: 0,
      open_book_exam: 0,
      attemptId: '',
      recordId: null,
      deadline: 0,
      remainingSeconds: 0,
      currentIndex: 0,
      loading: false,
      submitting: false,
      submitted: false,
      expired: false,
      feedbackVisible: false,
      feedbackIsCorrect: false,
      timer: null,
      debounceTimer: null,
      pendingSave: null,
      saveQueue: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(),
      pendingSaveOperationId: null,
      pendingSaveOperationVersion: null,
      pendingSubmit: null
    };
  },

  computed: {
    questionsType: function questionsType() {
      var _this = this;

      var item = __WEBPACK_IMPORTED_MODULE_4__training_question_constants__["o" /* opts */].questionTypeMaps.find(function (option) {
        return option.value === Number(_this.currentQuestion.question_type);
      });
      return item ? item.label : '-';
    },
    currentQuestion: function currentQuestion() {
      return this.questions[this.currentIndex];
    },
    isOpenBook: function isOpenBook() {
      return Number(this.open_book_exam) === 1;
    },
    currentQuestionFeedback: function currentQuestionFeedback() {
      var question = this.currentQuestion;
      var analysis = question && question.question_analysis && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(question.question_analysis) === 'object' ? question.question_analysis : {};
      return {
        standardAnswerText: question ? this.standardAnswerText(question) : '',
        analysisText: analysis.analysis_text || '',
        analysisFiles: Array.isArray(analysis.analysis_files) ? analysis.analysis_files : []
      };
    },
    answeredCount: function answeredCount() {
      var _this2 = this;

      return this.questions.filter(function (question) {
        return _this2.isAnswered(question.id);
      }).length;
    },
    countdownText: function countdownText() {
      var minutes = Math.floor(this.remainingSeconds / 60);
      var seconds = this.remainingSeconds % 60;
      return '' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }
  },
  created: function created() {
    this.loadExam();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.debounceTimer);
  },

  methods: {
    storageKey: function storageKey() {
      return '' + STORAGE_PREFIX + this.attemptId;
    },
    freshOperationId: function freshOperationId(prefix) {
      return operationId(prefix);
    },
    isSingle: function isSingle(question) {
      return question.question_type === __WEBPACK_IMPORTED_MODULE_4__training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
    },
    isMultiple: function isMultiple(question) {
      return question.question_type === __WEBPACK_IMPORTED_MODULE_4__training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI;
    },
    optionsOf: function optionsOf(question) {
      return question.options || question.option || [];
    },
    optionValue: function optionValue(option) {
      return option.value !== undefined ? option.value : option.uuid;
    },
    optionLabel: function optionLabel(option) {
      return option.label || option.name || option.value || option.uuid;
    },
    multipleAnswer: function multipleAnswer(id) {
      return Array.isArray(this.answers[id]) ? this.answers[id] : [];
    },
    standardAnswerText: function standardAnswerText(question) {
      var _this3 = this;

      if (!question || question.standard_answer === undefined || question.standard_answer === null) return '';
      var values = Array.isArray(question.standard_answer) ? question.standard_answer : [question.standard_answer];
      return values.filter(function (value) {
        return value !== null && value !== undefined && value !== '';
      }).map(function (value) {
        var option = _this3.optionsOf(question).find(function (item) {
          return String(_this3.optionValue(item)) === String(value);
        });
        return option ? _this3.optionLabel(option) : String(value);
      }).join('、');
    },
    isAnswered: function isAnswered(id) {
      var answer = this.answers[String(id)];
      return Array.isArray(answer) ? answer.some(function (item) {
        return item !== undefined && item !== null && String(item).trim() !== '';
      }) : answer !== undefined && answer !== null && String(answer).trim() !== '';
    },
    isAnswerCorrect: function isAnswerCorrect(question, answer) {
      var standardAnswer = question && question.standard_answer;
      if (standardAnswer === undefined || standardAnswer === null || answer === undefined || answer === null) {
        return false;
      }
      if (Array.isArray(standardAnswer) || Array.isArray(answer)) {
        if (!Array.isArray(standardAnswer) || !Array.isArray(answer)) return false;
        var expected = standardAnswer.map(String).sort();
        var actual = answer.map(String).sort();
        return expected.length === actual.length && expected.every(function (value, index) {
          return value === actual[index];
        });
      }
      if (Number(question.question_type) === __WEBPACK_IMPORTED_MODULE_4__training_question_constants__["b" /* consts */].QUESTION_TYPE_FILL_BLANK) {
        var actualNumber = Number(answer);
        var expectedNumber = Number(standardAnswer);
        return String(answer).trim() !== '' && isFinite(actualNumber) && actualNumber === expectedNumber;
      }
      return String(answer) === String(standardAnswer);
    },
    normalizeData: function normalizeData(response) {
      var data = response && response.data ? response.data : {};
      return data.data && !data.questions ? data.data : data;
    },
    normalizeAnswers: function normalizeAnswers(answers) {
      if (!answers || (typeof answers === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(answers)) !== 'object') return {};
      var normalized = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(answers).forEach(function (key) {
        // 转为字符串，防止出现大量的null值
        if (Array.isArray(answers) && answers[key] === null) return;
        normalized[String(key)] = answers[key];
      });
      return normalized;
    },
    loadExam: function loadExam() {
      var _this4 = this;

      this.loading = true;
      var params = {
        id: this.$route.params.id,
        record_id: this.$route.query && this.$route.query.record_id,
        attemptId: this.$route.query && this.$route.query.attemptId
      };
      return request.common('getSelfTrainingExam', params).then(function (response) {
        var data = _this4.normalizeData(response);
        _this4.title = data.title || data.exam_title || '';
        _this4.questions = data.questions || data.question_snapshots || [];
        _this4.attemptId = data.attemptId || data.attempt_id || params.attemptId || '';
        _this4.passing_score = data.passing_score || data.passing_score || '';
        _this4.question_score = data.question_score || data.question_score || '';
        _this4.open_book_exam = Number(data.open_book_exam) || 0;
        _this4.recordId = data.record_id || data.recordId || params.record_id;
        _this4.deadline = Number(data.deadline);
        var serverVersion = Number(data.version) || 0;
        var serverAnswers = _this4.normalizeAnswers(data.answers);
        var local = void 0;
        try {
          local = JSON.parse(localStorage.getItem(_this4.storageKey()) || 'null');
        } catch (e) {
          local = null;
        }
        if (local && Number(local.version) > serverVersion) {
          _this4.version = Number(local.version);
          _this4.answers = _this4.normalizeAnswers(local.answers);
          _this4.scheduleSave(true);
        } else {
          _this4.version = serverVersion;
          _this4.answers = serverAnswers;
          _this4.writeLocalStorage();
        }
        _this4.tick();
        clearInterval(_this4.timer);
        _this4.timer = setInterval(_this4.tick, 1000);
      }).catch(function () {
        _this4.$message.error('考试加载失败，请稍后重试');
      }).finally(function () {
        _this4.loading = false;
      });
    },
    writeLocalStorage: function writeLocalStorage() {
      if (!this.attemptId) return;
      try {
        localStorage.setItem(this.storageKey(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          attemptId: this.attemptId,
          version: this.version,
          answers: this.normalizeAnswers(this.answers)
        }));
      } catch (e) {}
    },
    selectAnswer: function selectAnswer(id, answer) {
      if (this.submitted || this.expired || this.submitting) return;
      if (Array.isArray(this.answers)) this.answers = this.normalizeAnswers(this.answers);
      this.$set(this.answers, id, answer);
      this.version += 1;
      this.writeLocalStorage();
      this.scheduleSave();
    },
    scheduleSave: function scheduleSave(immediate) {
      var _this5 = this;

      clearTimeout(this.debounceTimer);
      // 同一版本的网络重试复用 operationId；产生新版本时必须生成新的操作号。
      if (!this.pendingSaveOperationId || this.pendingSaveOperationVersion !== this.version) {
        this.pendingSaveOperationId = this.freshOperationId('draft');
        this.pendingSaveOperationVersion = this.version;
      }
      var save = function save() {
        var operationId = _this5.pendingSaveOperationId;
        var version = _this5.pendingSaveOperationVersion;
        var answers = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this5.normalizeAnswers(_this5.answers)));
        // 串行
        _this5.saveQueue = _this5.saveQueue.catch(function () {}).then(function () {
          return _this5.saveDraft(operationId, version, answers);
        });
        _this5.pendingSave = _this5.saveQueue;
        return _this5.pendingSave;
      };
      if (immediate) return save();
      this.pendingSave = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this5.debounceTimer = setTimeout(function () {
          return resolve(save());
        }, 1000);
      });
      return this.pendingSave;
    },
    saveDraft: function saveDraft(operationId, version, answers) {
      var _this6 = this;

      if (this.submitted || this.expired && !this.submitting || !this.attemptId) return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
      var currentOperationId = operationId || (this.pendingSaveOperationId = this.freshOperationId('draft'));
      var currentVersion = version === null || version === undefined ? this.version : version;
      return request.dispatch('saveSelfTrainingExamDraft', {
        record_id: this.recordId,
        attemptId: this.attemptId,
        version: currentVersion,
        answers: answers || JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.normalizeAnswers(this.answers))),
        operationId: currentOperationId
      }).then(function (response) {
        var data = response && response.data ? response.data.detail : {};
        if (Number(data.version) > _this6.version) _this6.version = Number(data.version);
        _this6.writeLocalStorage();
        if (_this6.pendingSaveOperationId === currentOperationId) {
          _this6.pendingSaveOperationId = null;
          _this6.pendingSaveOperationVersion = null;
        }
        return response;
      }).catch(function (error) {
        _this6.$message.warning('草稿保存失败，答案已保留在本地');
        throw error;
      });
    },
    submitExam: function submitExam(auto) {
      var _this7 = this;

      if (this.submitting || this.submitted || !this.attemptId) return this.pendingSubmit || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
      if (!auto && !this.isOpenBook) {
        console.log(this.answers);
        var unansweredIndex = this.questions.findIndex(function (question) {
          return !_this7.isAnswered(question.id);
        });
        if (unansweredIndex !== -1) {
          this.currentIndex = unansweredIndex;
          this.$message.warning('还有题目未作答，请完成后再提交，已自动跳转到未作答题目位置');
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(false);
        }
      }
      this.submitting = true;
      // 提交前取消防抖计时并立即把当前版本排入保存队列，避免最后一次选择尚未落 Redis。
      clearTimeout(this.debounceTimer);
      this.scheduleSave(true);
      var waitForSave = this.pendingSave || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
      this.pendingSubmit = waitForSave.catch(function () {}).then(function () {
        return request.common('submitSelfTrainingExam', {
          record_id: _this7.recordId,
          attemptId: _this7.attemptId,
          operationId: _this7.freshOperationId('submit')
        });
      }).then(function (response) {
        _this7.submitted = true;
        try {
          localStorage.removeItem(_this7.storageKey());
        } catch (e) {}
        _this7.$router.push('/training/self-examination');
        return response;
      }).catch(function (error) {
        _this7.submitting = false;
        throw error;
      });
      return this.pendingSubmit;
    },
    tick: function tick() {
      if (!this.deadline) return;
      this.remainingSeconds = Math.max(0, Math.ceil((this.deadline * 1000 - Date.now()) / 1000));
      if (this.remainingSeconds === 0 && !this.expired) {
        this.expired = true;
        clearInterval(this.timer);
        this.submitExam(true);
      }
    },
    previousQuestion: function previousQuestion() {
      if (this.currentIndex > 0) this.currentIndex -= 1;
    },
    nextQuestion: function nextQuestion() {
      if (this.isOpenBook) {
        if (!this.currentQuestion || !this.isAnswered(this.currentQuestion.id)) {
          this.$message.warning('请先作答当前题目');
          return false;
        }
        this.feedbackIsCorrect = this.isAnswerCorrect(this.currentQuestion, this.answers[String(this.currentQuestion.id)]);
        this.feedbackVisible = true;
        return this.feedbackIsCorrect;
      }
      if (this.currentIndex >= this.questions.length - 1) return false;
      this.currentIndex += 1;
      return true;
    },
    retryCurrentQuestion: function retryCurrentQuestion() {
      if (!this.feedbackVisible || this.feedbackIsCorrect || !this.currentQuestion) return false;
      this.$delete(this.answers, String(this.currentQuestion.id));
      this.version += 1;
      this.feedbackVisible = false;
      this.writeLocalStorage();
      this.scheduleSave();
      return true;
    },
    continueAfterCorrectAnswer: function continueAfterCorrectAnswer() {
      if (!this.feedbackVisible || !this.feedbackIsCorrect) return false;
      this.feedbackVisible = false;
      if (this.currentIndex === this.questions.length - 1) {
        return this.submitExam(false);
      }
      this.currentIndex += 1;
      return true;
    },
    goToQuestion: function goToQuestion(index) {
      if (this.isOpenBook && index > this.currentIndex) return false;
      this.currentIndex = index;
      return true;
    }
  }
});

/***/ }),

/***/ 5644:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5645);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("18ef9b9c", content, true, {});

/***/ }),

/***/ 5645:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".self-training-examination[data-v-518a269e]{min-height:calc(100vh - 160px);padding:24px 30px;background:#f5f7fa;color:#183153}.exam-page-header[data-v-518a269e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:18px}.exam-page-header h2[data-v-518a269e]{margin:0 0 5px}.exam-page-header p[data-v-518a269e]{margin:0;color:#7b8ba1}.exam-countdown[data-v-518a269e]{padding:9px 16px;border-radius:8px;background:#e8efff;color:#2165ff;font-size:18px;font-weight:600}.exam-countdown.danger[data-v-518a269e]{color:#e64d4d;background:#fff0f0}.exam-layout[data-v-518a269e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:20px}.exam-question-panel[data-v-518a269e]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.question-card[data-v-518a269e]{min-height:330px}.question-card .question-index[data-v-518a269e]{color:#2165ff;font-size:20px}.question-card h3[data-v-518a269e]{margin:18px 0 24px;line-height:1.7;font-size:18px;font-weight:500}.question-card .el-checkbox[data-v-518a269e],.question-card .el-radio[data-v-518a269e]{display:block;margin:18px 0}.question-samples[data-v-518a269e]{margin-bottom:24px}.question-actions[data-v-518a269e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-top:18px}.open-book-feedback[data-v-518a269e]{padding:16px 18px;border-left:4px solid #64748b;border-radius:0 4px 4px 0;background:#f5f7fa;color:#344054}.open-book-feedback.is-correct[data-v-518a269e]{border-left-color:#00a94f;background:#effaf3;color:#385342}.open-book-feedback.is-wrong[data-v-518a269e]{border-left-color:#e5484d;background:#fff1f1;color:#57383a}.open-book-feedback__status[data-v-518a269e]{margin-bottom:18px;font-size:20px;font-weight:600}.open-book-feedback__status i[data-v-518a269e]{margin-right:8px;font-size:24px;vertical-align:-2px}.open-book-feedback.is-correct .open-book-feedback__status[data-v-518a269e],.open-book-feedback.is-correct .open-book-feedback__title[data-v-518a269e]{color:#008e43}.open-book-feedback.is-wrong .open-book-feedback__status[data-v-518a269e],.open-book-feedback.is-wrong .open-book-feedback__title[data-v-518a269e]{color:#c7373d}.open-book-feedback.is-correct .open-book-feedback__answer[data-v-518a269e]{color:#006f35}.open-book-feedback.is-wrong .open-book-feedback__answer[data-v-518a269e]{color:#a6292f}.open-book-feedback__title[data-v-518a269e]{font-size:14px;font-weight:600}.open-book-feedback__answer[data-v-518a269e]{margin-top:8px;font-weight:600}.open-book-feedback__analysis[data-v-518a269e]{margin-top:16px;padding-top:14px;border-top:1px solid rgba(0,169,79,.2)}.open-book-feedback__analysis p[data-v-518a269e]{margin:8px 0 0;line-height:1.7}.answer-card[data-v-518a269e]{width:250px;padding:20px;border-radius:10px;background:#fff}.answer-card h3[data-v-518a269e]{margin:0 0 18px}.answer-card p[data-v-518a269e]{color:#7b8ba1;font-size:13px}.answer-grid[data-v-518a269e]{display:grid;grid-template-columns:repeat(5,1fr);gap:9px}.answer-grid button[data-v-518a269e]{width:36px;height:36px;border:1px solid #dfe5ed;border-radius:4px;color:#69788d;background:#fff;cursor:pointer}.answer-grid button.answered[data-v-518a269e]{border-color:#2165ff;color:#2165ff;background:#e8efff}.answer-grid button.active[data-v-518a269e]{color:#fff;background:#2165ff}@media (max-width:768px){.self-training-examination[data-v-518a269e]{padding:20px 16px}.exam-layout[data-v-518a269e]{display:block}.answer-card[data-v-518a269e]{width:auto;margin-top:18px}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/exam/SelfTrainingExamination.vue"],"names":[],"mappings":"AACA,4CAA4C,+BAA+B,kBAAkB,mBAAmB,aAAa,CAC5H,AACD,mCAAmC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,CACxP,AACD,sCAAsC,cAAc,CACnD,AACD,qCAAqC,SAAS,aAAa,CAC1D,AACD,iCAAiC,iBAAiB,kBAAkB,mBAAmB,cAAc,eAAe,eAAe,CAClI,AACD,wCAAwC,cAAc,kBAAkB,CACvE,AACD,8BAA8B,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,CAC9J,AACD,sCAAsC,mBAAmB,WAAW,OAAO,WAAW,CACrF,AACD,gCAAgC,gBAAgB,CAC/C,AACD,gDAAgD,cAAc,cAAc,CAC3E,AACD,mCAAmC,mBAAmB,gBAAgB,eAAe,eAAe,CACnG,AACD,uFAAuF,cAAc,aAAa,CACjH,AACD,mCAAmC,kBAAkB,CACpD,AACD,mCAAmC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,8BAA8B,eAAe,CACnL,AACD,qCAAqC,kBAAkB,8BAA8B,0BAA0B,mBAAmB,aAAa,CAC9I,AACD,gDAAgD,0BAA0B,mBAAmB,aAAa,CACzG,AACD,8CAA8C,0BAA0B,mBAAmB,aAAa,CACvG,AACD,6CAA6C,mBAAmB,eAAe,eAAe,CAC7F,AACD,+CAA+C,iBAAiB,eAAe,mBAAmB,CACjG,AACD,uJAAuJ,aAAa,CACnK,AACD,mJAAmJ,aAAa,CAC/J,AACD,4EAA4E,aAAa,CACxF,AACD,0EAA0E,aAAa,CACtF,AACD,4CAA4C,eAAe,eAAe,CACzE,AACD,6CAA6C,eAAe,eAAe,CAC1E,AACD,+CAA+C,gBAAgB,iBAAiB,sCAAuC,CACtH,AACD,iDAAiD,eAAe,eAAe,CAC9E,AACD,8BAA8B,YAAY,aAAa,mBAAmB,eAAe,CACxF,AACD,iCAAiC,eAAe,CAC/C,AACD,gCAAgC,cAAc,cAAc,CAC3D,AACD,8BAA8B,aAAa,oCAAqC,OAAO,CACtF,AACD,qCAAqC,WAAW,YAAY,yBAAyB,kBAAkB,cAAc,gBAAgB,cAAc,CAClJ,AACD,8CAA8C,qBAAqB,cAAc,kBAAkB,CAClG,AACD,4CAA4C,WAAW,kBAAkB,CACxE,AACD,yBACA,4CAA4C,iBAAiB,CAC5D,AACD,8BAA8B,aAAa,CAC1C,AACD,8BAA8B,WAAW,eAAe,CACvD,CACA","file":"SelfTrainingExamination.vue","sourcesContent":["\n.self-training-examination[data-v-518a269e]{min-height:calc(100vh - 160px);padding:24px 30px;background:#f5f7fa;color:#183153\n}\n.exam-page-header[data-v-518a269e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:18px\n}\n.exam-page-header h2[data-v-518a269e]{margin:0 0 5px\n}\n.exam-page-header p[data-v-518a269e]{margin:0;color:#7b8ba1\n}\n.exam-countdown[data-v-518a269e]{padding:9px 16px;border-radius:8px;background:#e8efff;color:#2165ff;font-size:18px;font-weight:600\n}\n.exam-countdown.danger[data-v-518a269e]{color:#e64d4d;background:#fff0f0\n}\n.exam-layout[data-v-518a269e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:20px\n}\n.exam-question-panel[data-v-518a269e]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.question-card[data-v-518a269e]{min-height:330px\n}\n.question-card .question-index[data-v-518a269e]{color:#2165ff;font-size:20px\n}\n.question-card h3[data-v-518a269e]{margin:18px 0 24px;line-height:1.7;font-size:18px;font-weight:500\n}\n.question-card .el-radio[data-v-518a269e],.question-card .el-checkbox[data-v-518a269e]{display:block;margin:18px 0\n}\n.question-samples[data-v-518a269e]{margin-bottom:24px\n}\n.question-actions[data-v-518a269e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-top:18px\n}\n.open-book-feedback[data-v-518a269e]{padding:16px 18px;border-left:4px solid #64748b;border-radius:0 4px 4px 0;background:#f5f7fa;color:#344054\n}\n.open-book-feedback.is-correct[data-v-518a269e]{border-left-color:#00a94f;background:#effaf3;color:#385342\n}\n.open-book-feedback.is-wrong[data-v-518a269e]{border-left-color:#e5484d;background:#fff1f1;color:#57383a\n}\n.open-book-feedback__status[data-v-518a269e]{margin-bottom:18px;font-size:20px;font-weight:600\n}\n.open-book-feedback__status i[data-v-518a269e]{margin-right:8px;font-size:24px;vertical-align:-2px\n}\n.open-book-feedback.is-correct .open-book-feedback__status[data-v-518a269e],.open-book-feedback.is-correct .open-book-feedback__title[data-v-518a269e]{color:#008e43\n}\n.open-book-feedback.is-wrong .open-book-feedback__status[data-v-518a269e],.open-book-feedback.is-wrong .open-book-feedback__title[data-v-518a269e]{color:#c7373d\n}\n.open-book-feedback.is-correct .open-book-feedback__answer[data-v-518a269e]{color:#006f35\n}\n.open-book-feedback.is-wrong .open-book-feedback__answer[data-v-518a269e]{color:#a6292f\n}\n.open-book-feedback__title[data-v-518a269e]{font-size:14px;font-weight:600\n}\n.open-book-feedback__answer[data-v-518a269e]{margin-top:8px;font-weight:600\n}\n.open-book-feedback__analysis[data-v-518a269e]{margin-top:16px;padding-top:14px;border-top:1px solid rgba(0,169,79,0.2)\n}\n.open-book-feedback__analysis p[data-v-518a269e]{margin:8px 0 0;line-height:1.7\n}\n.answer-card[data-v-518a269e]{width:250px;padding:20px;border-radius:10px;background:#fff\n}\n.answer-card h3[data-v-518a269e]{margin:0 0 18px\n}\n.answer-card p[data-v-518a269e]{color:#7b8ba1;font-size:13px\n}\n.answer-grid[data-v-518a269e]{display:grid;grid-template-columns:repeat(5, 1fr);gap:9px\n}\n.answer-grid button[data-v-518a269e]{width:36px;height:36px;border:1px solid #dfe5ed;border-radius:4px;color:#69788d;background:#fff;cursor:pointer\n}\n.answer-grid button.answered[data-v-518a269e]{border-color:#2165ff;color:#2165ff;background:#e8efff\n}\n.answer-grid button.active[data-v-518a269e]{color:#fff;background:#2165ff\n}\n@media (max-width: 768px){\n.self-training-examination[data-v-518a269e]{padding:20px 16px\n}\n.exam-layout[data-v-518a269e]{display:block\n}\n.answer-card[data-v-518a269e]{width:auto;margin-top:18px\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"self-training-examination"},[_c('header',{staticClass:"exam-page-header"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.title || '自助考试'))]),_vm._v(" "),_c('p',[_vm._v("共 "+_vm._s(_vm.questions.length)+" 题 · 满分 "+_vm._s(_vm.question_score * _vm.questions.length)+" 分 · 及格 "+_vm._s(_vm.passing_score)+"\n        分")])]),_vm._v(" "),_c('div',{staticClass:"exam-countdown",class:{ danger: _vm.remainingSeconds < 60 }},[_c('i',{staticClass:"el-icon-time"}),_vm._v(" "+_vm._s(_vm.countdownText)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"exam-layout"},[_c('main',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"exam-question-panel"},[(_vm.currentQuestion)?_c('el-card',{staticClass:"question-card"},[_c('div',{staticClass:"question-index"},[_vm._v("第 "+_vm._s(_vm.currentIndex + 1)+" 题\n          "),_c('span',{staticStyle:{"font-size":"14px"}},[_c('span',{staticClass:"text-xs text-gray-400",attrs:{"id":"q-type"}},[_vm._v(_vm._s(_vm.questionsType))]),_vm._v(" "),(!this.isOpenBook)?_c('span',{staticClass:"text-xs text-gray-400"},[_vm._v("（每题 "+_vm._s(this.question_score)+" 分）")]):_vm._e()])]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.currentQuestion.title))]),_vm._v(" "),_c('training-media-preview',{key:_vm.currentQuestion.id,staticClass:"question-samples",attrs:{"files":_vm.currentQuestion.sample_files}}),_vm._v(" "),(_vm.isSingle(_vm.currentQuestion))?_c('el-radio-group',{attrs:{"value":_vm.answers[_vm.currentQuestion.id],"disabled":_vm.submitted || _vm.expired},on:{"input":function($event){return _vm.selectAnswer(_vm.currentQuestion.id, $event)}}},_vm._l((_vm.optionsOf(_vm.currentQuestion)),function(option){return _c('el-radio',{key:_vm.optionValue(option),attrs:{"label":_vm.optionValue(option)}},[_vm._v("\n            "+_vm._s(_vm.optionLabel(option))+"\n          ")])}),1):(_vm.isMultiple(_vm.currentQuestion))?_c('el-checkbox-group',{attrs:{"value":_vm.multipleAnswer(_vm.currentQuestion.id),"disabled":_vm.submitted || _vm.expired},on:{"input":function($event){return _vm.selectAnswer(_vm.currentQuestion.id, $event)}}},_vm._l((_vm.optionsOf(_vm.currentQuestion)),function(option){return _c('el-checkbox',{key:_vm.optionValue(option),attrs:{"label":_vm.optionValue(option)}},[_vm._v("\n            "+_vm._s(_vm.optionLabel(option))+"\n          ")])}),1):_c('el-input',{attrs:{"value":_vm.answers[_vm.currentQuestion.id],"type":"textarea","disabled":_vm.submitted || _vm.expired},on:{"input":function($event){return _vm.selectAnswer(_vm.currentQuestion.id, $event)}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"question-actions"},[_c('el-button',{attrs:{"disabled":_vm.currentIndex === 0},on:{"click":_vm.previousQuestion}},[_vm._v("上一题\n        ")]),_vm._v(" "),(_vm.isOpenBook || _vm.currentIndex < _vm.questions.length - 1)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.nextQuestion}},[_vm._v("下一题\n        ")]):_c('el-button',{attrs:{"type":"primary","loading":_vm.submitting,"disabled":_vm.submitted || _vm.submitting},on:{"click":function($event){return _vm.submitExam(false)}}},[_vm._v("提交答卷\n        ")])],1)],1),_vm._v(" "),_c('aside',{staticClass:"answer-card"},[_c('h3',[_vm._v("答题卡")]),_vm._v(" "),_c('div',{staticClass:"answer-grid"},_vm._l((_vm.questions),function(question,index){return _c('button',{key:question.id,class:{ active: index === _vm.currentIndex, answered: _vm.isAnswered(question.id) },attrs:{"type":"button","disabled":_vm.isOpenBook && index > _vm.currentIndex},on:{"click":function($event){return _vm.goToQuestion(index)}}},[_vm._v(_vm._s(index + 1)+"\n        ")])}),0),_vm._v(" "),_c('p',[_vm._v("已答 "+_vm._s(_vm.answeredCount)+" / "+_vm._s(_vm.questions.length)+" 题")])])]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.feedbackVisible,"custom-class":_vm.feedbackIsCorrect ? 'open-book-feedback-dialog is-correct' : 'open-book-feedback-dialog is-wrong',"width":"min(560px, calc(100vw - 32px))","append-to-body":"","show-close":false,"close-on-click-modal":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.feedbackVisible=$event}}},[_c('div',{class:['open-book-feedback', _vm.feedbackIsCorrect ? 'is-correct' : 'is-wrong']},[_c('div',{staticClass:"open-book-feedback__status"},[_c('i',{class:_vm.feedbackIsCorrect ? 'el-icon-circle-check' : 'el-icon-circle-close'}),_vm._v("\n        "+_vm._s(_vm.feedbackIsCorrect ? '回答正确' : '回答错误')+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"open-book-feedback__title"},[_vm._v("正确答案")]),_vm._v(" "),_c('div',{staticClass:"open-book-feedback__answer"},[_vm._v("\n        "+_vm._s(_vm.currentQuestionFeedback.standardAnswerText || '-')+"\n      ")]),_vm._v(" "),(_vm.currentQuestionFeedback.analysisText || _vm.currentQuestionFeedback.analysisFiles.length)?_c('div',{staticClass:"open-book-feedback__analysis"},[_c('div',{staticClass:"open-book-feedback__title"},[_vm._v("题目解析")]),_vm._v(" "),(_vm.currentQuestionFeedback.analysisText)?_c('p',[_vm._v(_vm._s(_vm.currentQuestionFeedback.analysisText))]):_vm._e(),_vm._v(" "),_c('training-media-preview',{attrs:{"files":_vm.currentQuestionFeedback.analysisFiles}})],1):_vm._e()]),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(!_vm.feedbackIsCorrect)?_c('el-button',{attrs:{"type":"danger"},on:{"click":_vm.retryCurrentQuestion}},[_vm._v("重新作答")]):_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.continueAfterCorrectAnswer}},[_vm._v("\n        "+_vm._s(_vm.currentIndex === _vm.questions.length - 1 ? '提交答卷' : '下一题')+"\n      ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/self-training-examination-page.ceb7db09679cd7f4a13f.js